import { render, staticRenderFns } from "./SnWorkflow.vue?vue&type=template&id=f67580f4&scoped=true&"
import script from "./SnWorkflow.vue?vue&type=script&lang=js&"
export * from "./SnWorkflow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f67580f4",
  null
  
)

export default component.exports